define('Store.Profile.Model', [
    'Store.Cookie',
    'Profile.Model',
    'Store.Model',
    'underscore'
], function StoreProfileModel(
    StoreCookie,
    ProfileModel,
    StoreModel,
    _
) {
    'use strict';

    return {
        hookListeners: function hookListeners() {
            var profileModel = ProfileModel.getInstance();
            profileModel.on('change:store', function onChangeMethod(model, store) {
                model.set('store', store instanceof StoreModel ? store.clone() : new StoreModel(store), {
                    silent: true
                });
                if (model.get('store').get('internalid')) {
                    StoreCookie.set(model.get('store').get('internalid'));
                }
            });
            profileModel.trigger('change:store', profileModel, profileModel.get('store') || {});
        },
        setDefaultStore: function setDefaultStore() {
            var profile = ProfileModel.getInstance();
            var store = _.findWhere(SC.ENVIRONMENT.published.stores, { isPreferred: true });
            profile.set('store', new StoreModel(store));
        }
    };
});
